import { createApp } from 'vue'

import App from './App.vue'
import router from './router';

import * as Sentry from "@sentry/vue";
import { session } from '../../src/globals/session';

import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import '@/theme/tailwind.css';
import '@/theme/variables.css';
import '@/theme/custom.css';

/* v-calendar */
import 'v-calendar/style.css';
import VCalendar from 'v-calendar';

/* i18n */
import { i18n } from '@/i18n/i18n';


import Popper from "vue3-popper";

import Debug from '@/components/ui/Debug.vue';


const app = createApp(App)
  .use(IonicVue)
  .use(router)
  .use(VCalendar, {})
  .use(i18n)
  .component("Popper", Popper)
  .component("Debug", Debug);

declare const __APP_COMMIT__: string;

if (!import.meta.env.DEV) {
  Sentry.init({
    app,
    dsn: "https://b1ce99a8448531ceabbe7d5a115083e5@o119036.ingest.us.sentry.io/4511262655381505",
    release: __APP_COMMIT__,
    tracesSampleRate: 1.0,
    logErrors: true,
    ignoreErrors: [
      'OfflineCacheMissError',
      /^AxiosError: timeout of \d+ms exceeded$/,
      /^Error: Couldn't resolve component ".+" at ".+"$/,
      'AxiosError: Request aborted',
    ],
  });
}

function syncSentryUser() {
  if (session.account) {
    Sentry.setUser({
      id: session.account.id,
      email: session.account.email,
      institution_id: session.account.institution_id,
      employee_id: session.account.employee_id,
    });
  } else {
    Sentry.setUser(null);
  }
}
syncSentryUser();
session.on('change', syncSentryUser);
session.on('reset', syncSentryUser);

router.isReady().then(() => {
  app.mount('#app');
});
